import React, { Component } from 'react'
import { getBoundingClientRect } from '../utils/functions';
import { translate } from '../utils/useful';
import BatchConfirm from './modals/BatchConfirm';
import BatchUpdate from './modals/BatchUpdate';
import SidebarView from './SidebarView';
import StagesManager from './StagesManager';
import Administrators from './views/messenger/sideBar/Administrators';
import ChatSetting from './views/messenger/sideBar/ChatSetting';
import ContactInfo from './views/messenger/sideBar/ContactInfo';
import CreateGroup from './views/messenger/sideBar/CreateGroup';
import GroupInfo from './views/messenger/sideBar/GroupInfo';
import GroupType from './views/messenger/sideBar/GroupType';
import ManageGroup from './views/messenger/sideBar/ManageGroup';
import MessengerPermission from './views/messenger/sideBar/MeesengerPermission';
import MemberSearch from './views/messenger/sideBar/MemberSearch';
import MembersList from './views/messenger/sideBar/MembersList';
import SupportInfo from './views/messenger/sideBar/SupportInfo';
import SupportStatistic from './views/messenger/sideBar/SupportStatistic';
import Topics from './views/messenger/sideBar/Topics';
import TopicView from './views/messenger/sideBar/TopicView';




export default class TestPage extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        show: false,
        showContextMenu: false,
        xPos: "0",
        yPos: "0",



        option: [
            { icon: "/assets/icons/manage-gray.svg", title: "Manage Group", color: "#444", key: "manage" },
            { icon: "/assets/icons/leave-red.svg", title: "Leave Group", color: "#E61515", key: "leave" },
        ],

        MessengerContextMenu: [
            { icon: "/assets/icons/messenger/reply.svg", title: "Reply" },
            { icon: "/assets/icons/messenger/copy.svg", title: "Copy" },
            { icon: "/assets/icons/messenger/edit.svg", title: "Edit" },
            { icon: "/assets/icons/messenger/pin.svg", title: "Pin" },
            { icon: "/assets/icons/messenger/forward.svg", title: "Forward" },
            { icon: "/assets/icons/messenger/select.svg", title: "Select" },
            { icon: "/assets/icons/messenger/trash.svg", title: "Delete" },
        ]
    }

    componentDidMount = () => {
        // document.addEventListener("mousedown", this.handleClickOutside);
        document.addEventListener('click', () => {
            let { contextMenu } = this.state;
            contextMenu.show = false;
            this.setState({
                showContextMenu: false,
                contextMenu: contextMenu
            })
        })
        this.container.addEventListener('scroll', () => {
            // console.log("Test")
            if (this.state.showContextMenu) {
                this.setState({ showContextMenu: false })
            }
        })
    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openTopic = () => {
        this.topicView.openSidebar()
    }
    openContactInfo = () => {
        this.contactInfo.openSidebar()
    }

    openCreateGroup = () => {
        this.createGroup.openSidebar()
    }
    openSupportInfo = () => {
        this.supportInfo.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    openBatchUpdate = () => {
        this.batchUpdate.openSidebar()
    }

    onRightClickItem = (event, item, type) => {
        let currentItem = item;
        let corner = getBoundingClientRect(this.cornerDiv)

        this.setState({
            showContextMenu: true,
            contextMenu: {
                xPos: event.pageX - corner.left,
                yPos: event.pageY - corner.top,
                show: true,
                view: type
            },
            currentItem
        })
    }




    render() {
        let type = this.state.type
        return (
            <div ref={el => this.container = el} className='w-100 window-content-radius h-100 d-flex flex-column scroll-no-scrollbar' style={{ background: "#f6f6f6" }}>
                <div ref={el => this.cornerDiv = el} style={{ position: 'fixed', top: 0, left: 0, width: 1, height: 1 }}></div>
                <div className="">
                    <SidebarView hight={"100%"} width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                        <div className='w-100 h-100 scroll-no-scrollbar'>
                            <StagesManager ref={el => this.stageManager = el} fast={true}>
                                <GroupInfo width={this.props.width} changeStage={this.changePage} stage={0} stageName={'info'} />
                                <ManageGroup width={this.props.width} changeStage={this.changePage} stage={1} stageName={'manage'} />
                                <GroupType width={this.props.width} changeStage={this.changePage} stage={1} stageName={'grouptype'} />
                                <ChatSetting width={this.props.width} changeStage={this.changePage} stage={1} stageName={'chatsetting'} />
                                <MessengerPermission width={this.props.width} changeStage={this.changePage} stage={1} stageName={'permission'} />
                                <Administrators width={this.props.width} changeStage={this.changePage} stage={1} stageName={'adminestators'} />
                                <MembersList width={this.props.width} changeStage={this.changePage} stage={1} stageName={'members'} />
                                <Topics width={this.props.width} changeStage={this.changePage} stage={1} stageName={'topic'} />
                                <MemberSearch width={this.props.width} changeStage={this.changePage} stage={1} stageName={'search'} />
                            </StagesManager>
                        </div>
                    </SidebarView>
                    <SidebarView hight={"100%"} width={this.props.width} ref={el => this.topicView = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "40%", md: '35%', lg: "25", xl: "20%" }}>
                        <div className='w-100 h-100 scroll-no-scrollbar'>
                            <StagesManager ref={el => this.stageManager = el} fast={true}>
                                <TopicView width={this.props.width} changeStage={this.changePage} stage={0} stageName={'topic'} />
                            </StagesManager>
                        </div>
                    </SidebarView>
                    <SidebarView hight={"100%"} width={this.props.width} ref={el => this.contactInfo = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "40%", md: '35%', lg: "25", xl: "20%" }}>
                        <div className='w-100 h-100 scroll-no-scrollbar'>
                            <StagesManager ref={el => this.stageManager = el} fast={true}>
                                <ContactInfo width={this.props.width} height={"100%"} changeStage={this.changePage} stage={0} stageName={'topic'} />
                            </StagesManager>
                        </div>
                    </SidebarView>
                    <SidebarView hight={"100%"} width={this.props.width} ref={el => this.createGroup = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "40%", md: '35%', lg: "25", xl: "20%" }}>
                        <div className='w-100 h-100 scroll-no-scrollbar'>
                            <StagesManager ref={el => this.stageManager = el} fast={true}>
                                <CreateGroup width={this.props.width} height={"100%"} changeStage={this.changePage} stage={0} stageName={'topic'} />
                            </StagesManager>
                        </div>
                    </SidebarView>
                    <SidebarView hight={"100%"} width={this.props.width} ref={el => this.supportInfo = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "40%", md: '35%', lg: "25", xl: "20%" }}>
                        <div className='w-100 h-100 scroll-no-scrollbar'>
                            <StagesManager ref={el => this.stageManager = el} fast={true}>
                                <SupportInfo width={this.props.width} height={"100%"} changeStage={this.changePage} stage={0} stageName={'supportinfo'} />
                                <Administrators width={this.props.width} changeStage={this.changePage} stage={1} stageName={'adminestators'} />
                                <MessengerPermission width={this.props.width} changeStage={this.changePage} stage={1} stageName={'permission'} />
                                <SupportStatistic width={this.props.width} changeStage={this.changePage} stage={1} stageName={'statistics'} />
                            </StagesManager>
                        </div>
                    </SidebarView>
                    <SidebarView hight={"100%"} width={this.props.width} ref={el => this.batchUpdate = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }}>
                        <div className='w-100 h-100 scroll-no-scrollbar'>
                            <StagesManager ref={el => this.stageManager = el} fast={true}>
                                <BatchUpdate width={this.props.width} height={"100%"} changeStage={this.changePage} stage={0} stageName={'batch'} />
                                <BatchConfirm width={this.props.width} height={"100%"} changeStage={this.changePage} stage={1} stageName={'confirm'} />
                            </StagesManager>
                        </div>
                    </SidebarView>
                </div>
                <div className='flexcc h-100' style={{ flexDirection: "column" }} onContextMenu={(event) => { event.stopPropagation(); event.preventDefault(); this.onRightClickItem(event) }}>
                    <button style={{ backgroundColor: "#fff" }} onClick={() => this.openSidebar()} className='flexc px-5 py-4 br-20 shadow-1'>
                        <p className='text-link mrd-2'>Group Info</p>
                        <img width={15} src='/assets/icons/arrow-link.svg' />
                    </button>
                    <button style={{ backgroundColor: "#fff" }} onClick={() => this.openTopic()} className='flexc px-5 py-4 mt-4 br-20 shadow-1'>
                        <p className='text-link mrd-2'>Topic View</p>
                        <img width={15} src='/assets/icons/arrow-link.svg' />
                    </button>
                    <button style={{ backgroundColor: "#fff" }} onClick={() => this.openContactInfo()} className='flexc px-5 py-4 mt-4 br-20 shadow-1'>
                        <p className='text-link mrd-2'>Contact Info</p>
                        <img width={15} src='/assets/icons/arrow-link.svg' />
                    </button>
                    <button style={{ backgroundColor: "#fff" }} onClick={() => this.openCreateGroup()} className='flexc px-5 py-4 mt-4 br-20 shadow-1'>
                        <p className='text-link mrd-2'>Create Group</p>
                        <img width={15} src='/assets/icons/arrow-link.svg' />
                    </button>
                    <button style={{ backgroundColor: "#fff" }} onClick={() => this.openSupportInfo()} className='flexc px-5 py-4 mt-4 br-20 shadow-1'>
                        <p className='text-link mrd-2'>Suport Info</p>
                        <img width={15} src='/assets/icons/arrow-link.svg' />
                    </button>
                    <button style={{ backgroundColor: "#fff" }} onClick={() => this.openBatchUpdate()} className='flexc px-5 py-4 mt-4 br-20 shadow-1'>
                        <p className='text-link mrd-2'>Batch Update</p>
                        <img width={15} src='/assets/icons/arrow-link.svg' />
                    </button>
                </div>
                {this.state.showContextMenu && (
                    <div style={{ position: "fixed", top: this.state.contextMenu.yPos, left: this.state.contextMenu.xPos }}>
                        <div className='shadow-2 px-3 py-1 br-10 blur-bg' style={{ width: "150px" }}>
                            {this.state.MessengerContextMenu.map((prop, index) => {
                                return (
                                    <button className='flexcb w-100 py-2' style={{ borderBottom: "1px solid #eee" }}>
                                        <p>{prop.title}</p>
                                        <img width={22} src={prop.icon} />
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
